module.exports = __webpack_public_path__ + "static/media/thanks_img.f18403c0.png";